import { isMyApp } from '@/utils/validate'
import bridge from '@/utils/bridge'
import authority from '@/utils/authority'

// 缓存
let token = ''
let isOn = false
let isOnMusc = false
let isPageOn = false

// 获取token
export async function getToken() {
  if (token) return 'token'
  if (isMyApp) {
    const res = await bridge.callHandler({
      type: 'token'
    })
    token = res
    const user = authority.get() || {}
    user.token = token
    authority.set(user)
    return res
  }
  return ''
}

// 通知app编辑图片
export function editImage(item = {}) {
  return bridge.callHandler({
    type: 'image',
    data: item
  })
}
// 通知app编辑文字
export function editText(item = {}) {
  return bridge.callHandler({
    type: 'text',
    data: item
  })
}
// 通知app编辑信息
export function editInfo(item = {}) {
  return bridge.callHandler({
    type: 'cardinfo',
    data: item
  })
}

// APP控制音乐播放
export function switchMusic(callback) {
  if (isOnMusc) return
  isOnMusc = true
  bridge.registerHandler('switchMusic', callback)
}

// 通知APP音乐状态
export function notifyMusic(status = 1) {
  return bridge.callHandler({
    type: 'music',
    data: {
      status
    }
  })
}

// 通知APP音乐状态
export function notifyChangePage(page_id) {
  if (!page_id) return
  return bridge.callHandler({
    type: 'changepage',
    data: { page_id: String(page_id) }
  })
}

// app编辑成功通知
export function onEditSuccess(callback) {
  if (isOn) return
  isOn = true
  bridge.registerHandler('invitationEditSuccess', callback)
}

// app控制轮播
export function onChangePage(callback) {
  if (isPageOn) return
  isPageOn = true
  bridge.registerHandler('changePage', callback)
}

// 获取导航栏高度
export function getStatusHeight() {
  return bridge.callHandler({
    type: 'halo_ui_statusbar'
  })
}
